import axios from 'axios';
import Cookies from 'js-cookie';
import { authService } from '../auth/auth.service';

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Добавляем токен авторизации в каждый запрос
axiosInstance.interceptors.request.use((config) => {
  // Let the browser/Axios add the multipart boundary for file uploads.
  // Keeping the instance-wide application/json header makes FastAPI treat
  // FormData as JSON and respond with a 422 "file field required" error.
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  const token = Cookies.get('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Обрабатываем 401 ошибки
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Если ошибка 401 и это не запрос на обновление токена
    if (error.response?.status === 401 && !originalRequest._retry && originalRequest.url !== '/auth/refresh_token') {
      originalRequest._retry = true;

      try {
        const response = await authService.refreshToken();
        originalRequest.headers.Authorization = `Bearer ${response.access_token}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        authService.logout();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance; 
